<div class="alert-container">
  <div *ngFor="let alert of alerts" [@slideInOut] class="alert alert-{{alert.type}} alert-dismissible fade show">
    <ng-container *ngIf="isLoginRequiredAlert(alert.message) || isAddedToCartAlert(alert.message) ; else regularAlert">
      <!-- || isUpdatedCartAlert(alert.message) -->
      <span *ngIf="isLoginRequiredAlert(alert.message)">You must be logged in or <a style="text-decoration: underline;cursor: pointer;" (click)="enableGuestMode()">continue as a guest</a></span>
      <span *ngIf="isAddedToCartAlert(alert.message)">Added to <a style="text-decoration: underline;cursor: pointer;" (click)="goToCart()">cart</a></span>
      <span *ngIf="isUpdatedCartAlert(alert.message)">{{ alert.message }} <a style="text-decoration: underline;cursor: pointer;" (click)="goToCart()">Cart</a></span>
    </ng-container>
    <ng-template #regularAlert>
      {{ alert.message }}
    </ng-template>
    <button type="button" class="btn-close" (click)="remove(alert.id)"></button>
  </div>
</div>